<template>
  <div class="product-select-info-popover">
    <section class="top-section">
      <div class="d-flex flex-row align-items-start flex-nowrap">
        <HMFixedAspectRatioContainer class="img-container mr-3">
          <ProductThumbnail :product="product" :hideOverlay="true" />
        </HMFixedAspectRatioContainer>
        <div class="product-info d-flex flex-column align-items-start">
          <div class="d-flex flex-row flex-wrap">
            <HMProductTag
              v-for="tag in product.tags"
              :key="tag.id"
              class="mb-2 mr-2"
              :selected="tag.selected"
            >
              {{ tag.name }}
            </HMProductTag>
          </div>
          <span class="c-charcoal">{{ product.product_name }}</span>
          <span class="smallest mt-2">
            {{ $t('PRODUCTS.LABELS.DATE_CREATED') }}:
            {{ $formatDate(product.created) }}
          </span>
        </div>
      </div>
      <div
        class="card-content mt-3 d-flex align-items-start justify-content-start text-left"
      >
        <v-clamp autoresize :max-lines="4">
          {{
            strip(product.product_description, product.product_description_new)
          }}
        </v-clamp>
      </div>
    </section>
    <section class="bottom-section"></section>
  </div>
</template>

<script>
import ProductThumbnail from '@/web/components/products/ProductThumbnail.vue';
import { getProductTypeTranslations } from '@/core/utils/products';
import { renderHtmlFromEditorJS } from '@/core/utils/utils';
import VClamp from 'vue-clamp';

export default {
  name: 'ProductSelectInfoPopover',
  components: {
    ProductThumbnail,
    VClamp,
  },
  props: {
    product: {
      type: Object,
    },
  },
  methods: {
    getProductType() {
      return getProductTypeTranslations(this.product.product_type);
    },
    strip(html, json) {
      let useHtml = html;
      if (json) {
        useHtml = renderHtmlFromEditorJS(json);
      }
      if (!useHtml) {
        return '';
      }

      const doc = new DOMParser().parseFromString(useHtml, 'text/html');
      return doc.body.textContent || '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.product-select-info-popover {
  background-color: white;
  border-radius: $border-radius;
}

.img-container {
  min-width: 140px;
  width: 140px;
}

.bottom-section {
  background-color: $light-gray;
}
</style>
